module.exports = __webpack_public_path__ + "img/summit-hero.ebe2a86b.jpg";